/**
 * ClassificationModel (AJIP-16.02.005 · WS5)
 * ---------------------------------------------------------------------
 * Configuration-driven journey classification vocabularies. Frozen.
 * Classification does not determine customer-facing presentation.
 */

const JOURNEY_TYPES = Object.freeze([
  'founder', 'buyer', 'supplier', 'factory', 'brand', 'administrator', 'custom',
]);

const JOURNEY_CATEGORIES = Object.freeze([
  'onboarding', 'sourcing', 'verification', 'operational', 'moderation', 'discovery',
]);

const JOURNEY_AUDIENCES = Object.freeze([
  'authenticated', 'anonymous', 'authorised-founder', 'authorised-buyer',
  'authorised-supplier', 'authorised-factory', 'authorised-brand', 'authorised-administrator',
]);

const LIFECYCLE_STATUS = Object.freeze(['active', 'transitional', 'deprecated', 'archived']);
const AVAILABILITY = Object.freeze(['available', 'unavailable', 'coming-soon', 'retired']);

const isKnown = (collection, value) => collection.includes(value);

export {
  JOURNEY_TYPES, JOURNEY_CATEGORIES, JOURNEY_AUDIENCES,
  LIFECYCLE_STATUS, AVAILABILITY, isKnown,
};
